{
  "name": "dtis-ng-components",
  "version": "1.35.0",
  "scripts": {
    "ng": "nx",
    "mock": "tsx tools/mock-server/server.ts",
    "mock:prism": "prism mock mock.openapi.yaml ",
    "mock:ultrasonic": "prism mock apps/dtis-ultrasonic-ui/swagger.json --port 4010",
    "start:mock": "concurrently \"pnpm mock\" \"nx serve dtis-ng-components --host=127.0.0.1 --configuration=dev-cloud-mock\"",
    "start": "nx run-many -t serve --host=127.0.0.1 ",
    "start:dtis-prod": "nx run-many -t serve --host=127.0.0.1 --configuration=production",
    "start:dtis": "nx serve dtis-ng-components --host=127.0.0.1 ",
    "start:ut": "nx serve dtis-ultrasonic-ui --host=127.0.0.1 ",
    "start:admin": "nx serve dtis-admin --host=127.0.0.1 ",
    "build": "nx run-many -t build",
    "biome-lint": "biome lint",
    "lint": "nx run-many -t biome-lint --parallel=3",
    "lint:affected": "nx affected -t lint --parallel=3",
    "lint:fix": "nx run-many -t lint --parallel=3 --fix",
    "e2e:watch": "nx e2e dtis-test --runner-ui  --headed",
    "e2e": "pnpm run test:e2e",
    "e2e:component-test": "nx component-test dtis-ng-components",
    "test": "nx run-many -t test",
    "test:project": "nx test",
    "test:ut": " nx test dtis-ultrasonic-ui",
    "test:watch": "BABEL_DISABLE_CACHE=1  nx test dtis-ng-components --watchAll --coverage",
    "test:e2e": "NODE_OPTIONS='--max-old-space-size=4096' nx e2e dtis-test --browser=electron --verbose",
    "release:prepare": "npx release-please release-pr --token=$GITHUB_TOKEN --repo-url=Schaeffler-Group/dtis-ng-components",
    "release:artifact": "npx release-please github-release --token=$GITHUB_TOKEN --repo-url=Schaeffler-Group/dtis-ng-components",
    "prepare": "husky"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "22.2.5",
    "@angular/common": "22.2.3",
    "@angular/compiler": "22.2.3",
    "@angular/core": "22.2.3",
    "@angular/forms": "22.2.3",
    "@angular/material": "22.2.3",
    "@angular/platform-browser": "22.2.3",
    "@angular/platform-browser-dynamic": "22.2.3",
    "@angular/router": "22.2.3",
    "@azure/msal-angular": "6.2.3",
    "@azure/msal-browser": "5.25.1",
    "@fontsource/material-icons-outlined": "^5.3.0",
    "@fontsource/noto-sans": "^5.3.0",
    "@fontsource/roboto": "^5.3.0",
    "@jsverse/transloco": "^8.4.0",
    "@microsoft/applicationinsights-web": "~3.4.5",
    "@microsoft/microsoft-graph-client": "^3.0.7",
    "@ngxs/devtools-plugin": "22.0.0",
    "@ngxs/router-plugin": "^22.0.0",
    "@ngxs/storage-plugin": "^22.0.0",
    "@ngxs/store": "22.0.0",
    "@nx/angular": "23.3.0",
    "@nx/cypress": "23.3.0",
    "@schaeffler/empty-states": "^3.1.2",
    "@schaeffler/styles": "^1.14.3",
    "angular-svg-icon": "^19.1.1",
    "chroma-js": "^3.2.0",
    "colorjs.io": "^0.7.1",
    "date-fns": "4.4.0",
    "dexie": "^4.4.6",
    "echarts": "^6.1.0",
    "file-saver": "^2.0.5",
    "immer": "^11.1.21",
    "jszip": "^3.10.2",
    "material-icons": "^1.13.14",
    "mathjs": "^15.2.0",
    "modern-screenshot": "^4.7.0",
    "ngx-capture": "^0.14.0",
    "ngx-echarts": "^22.0.0",
    "ngx-papaparse": "^8.0.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^14.0.3",
    "zone.js": "0.16.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "22.2.3",
    "@angular-devkit/core": "22.2.3",
    "@angular-devkit/schematics": "22.2.3",
    "@angular/cli": "~22.2.3",
    "@angular/compiler-cli": "22.2.3",
    "@angular/language-service": "22.2.3",
    "@babel/core": "^8.0.7",
    "@biomejs/biome": "^2.5.15",
    "@cypress/webpack-dev-server": "6.1.0",
    "@juggle/resize-observer": "^3.4.0",
    "@microsoft/microsoft-graph-types": "^2.43.1",
    "@ngneat/spectator": "22.1.0",
    "@ngxs/logger-plugin": "^22.0.0",
    "@nx/jest": "23.3.0",
    "@nx/js": "23.3.0",
    "@nx/web": "23.3.0",
    "@nx/workspace": "23.3.0",
    "@schematics/angular": "22.2.3",
    "@swc-node/register": "1.12.1",
    "@swc/core": "1.16.18",
    "@swc/helpers": "0.5.23",
    "@tailwindcss/postcss": "^4.3.3",
    "@types/chroma-js": "^3.1.2",
    "@types/file-saver": "^2.0.7",
    "@types/jest": "30.0.0",
    "@types/node": "26.6.5",
    "babel-loader": "^10.1.1",
    "concurrently": "^10.0.6",
    "cypress": "16.2.0",
    "fake-indexeddb": "^6.2.6",
    "html-webpack-plugin": "^5.6.8",
    "https-proxy-agent": "9.1.0",
    "husky": "^9.1.7",
    "jest": "30.5.2",
    "jest-environment-jsdom": "30.5.2",
    "jest-junit": "^17.0.0",
    "jest-preset-angular": "17.0.3",
    "jest-util": "30.5.1",
    "lint-staged": "^17.6.0",
    "nx": "23.3.0",
    "prettier": "^3.9.10",
    "prettier-plugin-tailwindcss": "^0.8.1",
    "resize-observer-polyfill": "^1.5.1",
    "tailwindcss": "^4.3.3",
    "ts-jest": "29.4.15",
    "ts-node": "^10.9.2",
    "typescript": "6.0.3",
    "wait-on": "^9.5.1"
  },
  "lint-staged": {
    "*.{js,ts,cjs,mjs,d.cts,d.mts,jsx,tsx,json,jsonc}": [
      "biome check --write --no-errors-on-unmatched --diagnostic-level=error"
    ]
  }
}
